import React, {Component} from "react";
import withAuth from "../high-order-components/Auth-HOC";
import PostContactService from "../../services/PostContactService";
import {message} from "../ui-kit/MessageGate";
import i18nRepo from "../../i18n-repo/i18nRepo";
import {setLoading} from "../../store/actions/creators/appActionCreator";
import {connect} from "react-redux";
import moment from "moment";

class BlogContact extends Component
{
  constructor (props)
  {
    super(props);

    this.service = new PostContactService();

    this.state = {
      documents: []
    }
  }

  async componentDidMount ()
  {
    try
    {
      this.props.setLoading(true);

      const documents = (await this.service.get({}, this.props.language)).documents

      this.setState((previousState, props) => ({
        documents: documents
      }))
    }
    catch (error)
    {
      if (error.statusCode === 401)
      {
        this.props.authActions.logout();
      }

      message({
                type: "error",
                content: i18nRepo.getError("there_is_a_problem_with_getting_your_contact_data")
              });
    }
    finally
    {
      this.props.setLoading(false);
    }
  }

  render ()
  {
    return (
      <div className={"initial-page blog-contact"}>
        <div className={"blog-contact__header"}>
          {
            i18nRepo.getWord("blog_contact")
          }
        </div>

        <div className={"blog-contact__content-container"}>
          {
            this.state.documents.map((data, index) => (
              <div
                key={index}
                className={"blog-contact__content"}
              >
                <div className={"blog-contact__content-top"}>
                  <div className={"blog-contact__content-client-container"}>
                    <div className={"blog-contact__content-client-data"}>
                      <div className={"blog-contact__content-client-data-label"}>
                        {
                          i18nRepo.getWord("name") + ":"
                        }
                      </div>

                      <div className={"blog-contact__content-client-data-value"}>
                        {
                          data.firstName + " " + data.lastName
                        }
                      </div>
                    </div>

                    <div className={"blog-contact__content-client-data"}>
                      <div className={"blog-contact__content-client-data-label"}>
                        {
                          i18nRepo.getWord("email") + ":"
                        }
                      </div>

                      <div className={"blog-contact__content-client-data-value"}>
                        {
                          data.email
                        }
                      </div>
                    </div>

                    <div className={"blog-contact__content-client-data"}>
                      <div className={"blog-contact__content-client-data-label"}>
                        {
                          i18nRepo.getWord("phone") + ":"
                        }
                      </div>

                      <div className={"blog-contact__content-client-data-value"}>
                        {
                          data.phone
                        }
                      </div>
                    </div>
                  </div>

                  <div className={"blog-contact__content-date"}>
                    {
                      moment(data.createdAt).format("DD-MM-YYYY")
                    }
                  </div>

                </div>

                <div className={"blog-contact__content-bottom"}>
                  <div className={"blog-contact__content-subject"}>
                    <div className={"blog-contact__content-label"}>
                      {
                        i18nRepo.getWord("blog") + " :"
                      }
                    </div>

                    {
                      data?.post?.subject
                    }
                  </div>

                  <div className={"blog-contact__content-subject"}>
                    <div className={"blog-contact__content-label"}>
                      {
                        i18nRepo.getWord("subject") + " :"
                      }
                    </div>

                    {
                      data.subject
                    }
                  </div>

                  <div className={"blog-contact__content-content"}>
                    <div className={"blog-contact__content-label"}>
                      {
                        i18nRepo.getWord("content") + " :"
                      }
                    </div>

                    {
                      data.content
                    }
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setLoading: (loading) => dispatch(setLoading(loading))
});

export default withAuth(connect(null, mapDispatchToProps)(BlogContact));